// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"ReactionIcon_tooltip__JfPsV"};